import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { data, useNavigate } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import ManagerHeader from './ManagerHeader'

export default function AddAllocateBed() {
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [beds, setBeds] = useState([])
    const [newAdmission, setNewAdmission] = useState([])

    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
      category:'',
      bed:'',
      name:''
    })

    const [errors, setErrors] = useState({
      category:'',
      bed:'',
      name:''
    })

    const handleChange = (e) => {
      const {name, value} = e.target

      if(name === 'category'){
        setFormData((prev) => ({
          ...prev,
          category:value,
          bed:'',
          name:''
        }))

        setErrors((prev) => ({
          ...prev,
          bed:'',
          category:'',
          name:''
        }))

        return
      }

      if(name === 'bed'){
        setFormData((prev) => ({
          ...prev,
          bed:value,
          name:''
        }))

        setErrors((prev) => ({
          ...prev,
          bed:'',
          name:''
        }))

        return
      }

      setFormData((prev) => ({
        ...prev,
        [name]:value
      }))

      setErrors((prev) => ({
        ...prev,
        [name]:''
      }))
    }

    const validateForm = (data) => {
      const newErrors = {}

      if(!String(data.bed || '').trim()){
        newErrors.bed = "Please Select Bed"
      }

      if(!String(data.category || '').trim()){
        newErrors.category = 'Please Select Category'
      }

      if(!String(data.name || '').trim()){
        newErrors.name = 'Please Select name'
      }

      return newErrors
    }

    const fetchBeds = async() => {
      try{
        const res = await axios.get(`${config.baseurl}get_unallocated_beds/`, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })
        console.log('Bed Res:', res)

        if(res.status === 200){
          setBeds(res.data.data || [])
        }else{
          toast.error('Failed to fetch beds')
        }
      }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to create Department'

        toast.error(message)
      }
    }

    const fetchNewAdmissions = async() => {
      try{
        const res = await axios.get(`${config.baseurl}get_unallocated_admissions/`, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })
        console.log('New Admission Res:', res)

        if(res.status === 200){
          setNewAdmission(res.data.data)
        }else{
          toast.error('Failed to fetch New Admissions')
        }
      }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to create Department'

        toast.error(message)
      }
    }

    useEffect(() => {
      fetchBeds()
      fetchNewAdmissions()
    },[token])
    console.log('All Beds:', beds)
    console.log('All New Admissions:', newAdmission)

    const filteredBeds = beds.filter((bed) => {
      if(!formData.category){
        return false
      }

      return(
        String(bed.bed_type || '').trim().toLowerCase() === String(formData.category || '').trim().toLowerCase()
      )
    })

    const filteredAdmissions = newAdmission.filter((admission) => {
      if (!formData.category) {
        return false
      }

      return (
        String(admission.category || '').trim().toLowerCase() === String(formData.category || '').trim().toLowerCase()
      )
    })

    const handleSubmit = async(e) => {
      e.preventDefault()

      const validationErrors = validateForm(formData)

      setErrors(validationErrors)

      if(Object.keys(validationErrors).length > 0){
        const firstError = Object.values(validationErrors)[0]
        toast.error(firstError)
        return
      }

      setLoading(true)

      try{
        const payload = {
          bed:Number(formData.bed),
          category:formData.category,
          name:Number(formData.name)
        }
        console.log('Payload:', payload)

        const res = await axios.post(`${config.baseurl}allocate_bed/`, payload, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })
        console.log('Create Bed Allocate:', res.data)

        if(res.status === 200 || res.status === 201){
          toast.success(res.data?.message || 'Bed Allocated created successfully')
          setFormData({
            bed:'',
            category:'',
            name:''
          })

          setErrors({
            bed:'',
            category:'',
            name:''
          })

          setTimeout(() => {
            navigate(-1)
          },300)
        }else{
          toast.error(res.data?.message || 'Failed to create bed allocated')
        }
      }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to allocate bed'

        toast.error(message === 'object' ? JSON.stringify(message) : message)
      }finally{
        setLoading(false)
      }
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0">
      <ManagerHeader/>

      {/* HEADER */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
        <div className="items-center justify-between text-center">
          <h1 className="mt-1 text-3xl font-bold text-slate-800">
            Allocate Beds to New Admissions
          </h1>

          <p className="mt-2 text-sm text-slate-500">
            Allocate a Beds to a new admission.
          </p>
        </div>
      </div>

      {/* FORM SECTION */}
      <div className="max-w-7xl mx-auto px-6 pb-12">            
        <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 md:p-8">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              {/* Category */}
              <div className="md:col-span-2">
                <label
                  htmlFor="Category"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Category
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.category
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Caegory</option>
                  <option value="Child">Child</option>
                  <option value="Aged Person">Aged Person</option>
                </select>

                {errors.category && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.category}</p>
                )}
              </div>

              {/* Bed Number */}
              <div className="md:col-span-2">
                <label
                  htmlFor="bed"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Bed
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id='bed'
                  name='bed'
                  value={formData.bed}
                  onChange={handleChange}
                  disabled={!formData.category}
                  className={`${inputClass} ${
                    errors.bed ? 'border-red-500 focus:border-red-600' : ''
                  } ${
                    !formData.category ? 'cursor-not-allowed bg-slate-100' : ''
                  }`}
                >
                  <option value="">
                    {!formData.category 
                      ? 'Select Category first' 
                      : filteredBeds.length === 0
                        ? 'No Beds Available'
                        :'Select Bed'
                      }
                  </option>
                  {filteredBeds.map((bed) => (
                    <option key={bed.id} value={bed.id}>
                      Bed {bed.bed_no}
                    </option>
                  ))}
                </select>

                {errors.bed && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.bed}</p>
                )}
              </div>

              {/* name */}
              <div className="md:col-span-2">
                <label
                  htmlFor="name"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  New Admission
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={!formData.category}
                  className={`${inputClass} ${
                    errors.name ? 'border-red-500 focus:border-red-600' : ''
                  } ${
                    !formData.category ? 'cursor-not-allowed bg-slate-100' : ''
                  }`}
                >
                  <option value="">
                    {!formData.category 
                      ? 'Select Category first' 
                      : filteredAdmissions.length === 0
                        ? 'No New Admissions Available'
                        :'Select New Admission'
                      }
                  </option>
                  {filteredAdmissions.map((admission) => (
                    <option
                      key={admission.id}
                      value={admission.id}
                    >
                      {admission.first_name}{' '}{admission.last_name}
                    </option>
                  ))}
                </select>

                {errors.name && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.name}</p>
                )}
              </div>
            </div>

            {/* Form Actions */}
            <div className="mt-8 flex flex-row gap-3 border-t border-slate-200 pt-6 2xl:flex-col-reverse justify-end">
              <button
                type="button"
                onClick={() => navigate(-1)}
                disabled={loading}
                className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={loading}
                className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
